/**************************************************
 * Nombre:       Home_Vista_Sets
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import '@splidejs/react-splide/css';
import {useContext, useEffect, useState} from "react";
import uno from '../../../Recursos/vista_uno.png'
import dos from '../../../Recursos/vista_dos.png'
import tres from '../../../Recursos/vista_tres.png'
import producto from "../../../Recursos/tmp_producto.png";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {where} from "firebase/firestore";
import {contexApp} from "../../../App";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";
import Tarjeta_Vista_Sets from "../../Tarjetas/Tarjeta_Vista_Sets";

const Home_Vista_Sets = () => {
    const cData = useContext(contexApp)
    const {sCell} = useResponsive()
    const [sets, setSets] = useState([])


    const pasarTernas = (array) => {
        const resultado = [];
        for (let i = 0; i < array.length; i += 3) {
            resultado.push(array.slice(i, i + 3));
        }
        return resultado;
    }

    useEffect(() => {

        if (cData.actColeccion.id) {
            let idCol = cData.actColeccion.id
            let w = [where('idColeccion', '==', idCol)]
            obtenerColWheres({col: 'fotos', wheres: w}).then((dox) => {
                if (dox.res) {
                    let data = pasarTernas(dox.data)
                    setSets(data)
                }
            })

        }

    }, [cData]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 0 : 6}}

            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    {sets.map((arr, index) => {
                        return (
                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 10}}>
                                <Tarjeta_Vista_Sets arrItem={arr}/>
                            </Grid>
                        )
                    })}
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Home_Vista_Sets

const items = [
    uno,
    dos,
    tres
]

const productos = [
    {
        nombre: 'Blusa Ocre',
        img: producto,
        valor: 50000
    },
    {
        nombre: 'Blusa Ocre',
        img: producto,
        valor: 50000
    },
    {
        nombre: 'Blusa Ocre',
        img: producto,
        valor: 50000
    },
    {
        nombre: 'Blusa Ocre',
        img: producto,
        valor: 50000
    },
    {
        nombre: 'Blusa Ocre',
        img: producto,
        valor: 50000
    },

    {
        nombre: 'Blusa Ocre',
        img: producto,
        valor: 50000
    },
]